module.exports = __webpack_public_path__ + "img/edit.f5505a5a.png";